import React from "react";
import { DashboardLayout } from "@/components/dashboard/dashboard-layout";
import CalendarApp from "@/components/calendar/CalendarApp";

export default function CalendarPage() {
  return (
    <DashboardLayout>
      <div className="space-y-6">
        <h1 className="text-3xl font-bold tracking-tight">My Calendar</h1>
        <CalendarApp />
      </div>
    </DashboardLayout>
  );
}
